import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useRefreshShippingMethods(shopId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation<"post", "/shops/{shopId}/exchanges/shipping-methods/refresh", void>(
    "post",
    "/shops/{shopId}/exchanges/shipping-methods/refresh",
    {
      invalidate: invalidateShop,
      mapVariables: () => ({
        params: { path: { shopId } },
      }),
    },
  );
}
